import { resolveProductAvailability } from "../presentation/availability";

const hasApplicablePromoProduct = (product, promotions = {}, smartPromos = []) => {
  const productPromos = Array.isArray(promotions.products)
    ? promotions.products
    : [];
  if (
    productPromos.some(
      (promotion) =>
        Number(promotion.quantity) > 0 &&
        ((promotion.has_variants && promotion.product === product.parent) ||
          (!promotion.has_variants && promotion.product === product.id)),
    )
  ) {
    return true;
  }

  const categoryPromos = Array.isArray(promotions.category_free)
    ? promotions.category_free
    : [];
  return categoryPromos.some((promotion) => {
    if (
      Number(promotion.quantity) <= 0 ||
      !Array.isArray(promotion.categories) ||
      !promotion.categories.includes(product.category_id)
    ) {
      return false;
    }
    const configuredPromotion = (Array.isArray(smartPromos) ? smartPromos : []).find(
      ({ id }) => id === promotion.promo,
    );
    if (!configuredPromotion) return true;
    const excludedProducts = Array.isArray(configuredPromotion.excluded_products)
      ? configuredPromotion.excluded_products
      : [];
    const excludedCategories = Array.isArray(
      configuredPromotion.excluded_categories,
    )
      ? configuredPromotion.excluded_categories
      : [];
    return !(
      excludedCategories.includes(product.category_id) ||
      excludedProducts.some(
        (productId) => product.id === productId || product.parent === productId,
      )
    );
  });
};

export const canUseStorefrontQuickAdd = ({
  availabilityContext = {},
  categories = [],
  product,
  promotions = {},
  settings = {},
  smartPromos = [],
} = {}) => {
  if (!product || typeof product !== "object") return false;
  if (
    !settings.enable_quick_add_to_cart ||
    settings.is_menu ||
    product.show_quick_add_to_cart !== true ||
    product.hide_buy_button ||
    product.not_available ||
    product.available === false
  ) {
    return false;
  }
  if (
    product.has_variants ||
    ["bookable", "service"].includes(product.type_of_product) ||
    product.has_required_options !== false ||
    product.has_required_extra_fields !== false ||
    product.no_mingling ||
    product.pickup_only ||
    product.delivery_only ||
    product.cash_only ||
    product.credit_only ||
    product.requires_confirmation_message === true ||
    product.requires_pdp_hydration === true
  ) {
    return false;
  }

  const options = Array.isArray(product.options) ? product.options : [];
  if (
    options.some(
      (option) =>
        option.is_required ||
        (Array.isArray(option.choices) &&
          option.choices.some((choice) => Number(choice.preselected) > 0)),
    ) ||
    product.price_summary?.includes_preselected_options === true
  ) {
    return false;
  }
  if (Array.isArray(product.extra_fields) && product.extra_fields.length) {
    return false;
  }

  if (product.published_date) {
    const publishedAt = Date.parse(product.published_date);
    if (Number.isFinite(publishedAt) && publishedAt >= Date.now()) return false;
  }
  if (
    !Array.isArray(categories) ||
    !categories.some(({ id }) => String(id) === String(product.category_id))
  ) {
    return false;
  }
  if (hasApplicablePromoProduct(product, promotions, smartPromos)) return false;

  const availability = resolveProductAvailability(product, availabilityContext);
  return availability.available && availability.status === "available";
};

export const needsStorefrontProductDetails = (product = {}) =>
  product.has_required_options === true ||
  product.has_required_extra_fields === true ||
  (Array.isArray(product.options) &&
    product.options.some((option) => option?.is_required === true)) ||
  (Array.isArray(product.extra_fields) &&
    product.extra_fields.some((field) => field?.is_required === true));

export const shouldShowStorefrontDetailsAction = ({
  product = {},
  settings = {},
} = {}) =>
  settings.enable_quick_add_to_cart === true &&
  settings.is_menu !== true &&
  product.show_quick_add_to_cart === true &&
  product.hide_buy_button !== true &&
  product.not_available !== true &&
  product.available !== false &&
  needsStorefrontProductDetails(product);
